export const TicketThread = ({ ticket, me }) => (
  <div className="space-y-3 max-h-[420px] overflow-y-auto pr-1" data-testid="ticket-thread">
    {ticket.messages.map((m, i) => {
      const mine = m.from === me;
      return (
        <div key={i} className={`flex ${mine ? "justify-end" : "justify-start"}`}>
          <div className={`max-w-[80%] rounded-2xl px-4 py-2.5 text-sm ${mine ? "bg-[#D4AF37]/20 border border-[#D4AF37]/40" : "bg-white/5 border border-white/10"}`}>
            <p className="text-[10px] uppercase tracking-[0.15em] text-zinc-500 mb-1">{m.from === "admin" ? "Dəstək" : "Müştəri"} · {new Date(m.at).toLocaleString("az-AZ")}</p>
            <p className="whitespace-pre-wrap">{m.text}</p>
          </div>
        </div>
      );
    })}
  </div>
);

export const TICKET_STATUS = {
  open: ["Cavab gözləyir", "text-amber-400 bg-amber-400/10"],
  answered: ["Cavablandı", "text-emerald-400 bg-emerald-400/10"],
  closed: ["Bağlandı", "text-zinc-400 bg-white/5"],
};

